module.exports = __webpack_public_path__ + "img/plans.50d0eb1c.svg";